import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, User, Award } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { getWebinarThumbnail } from '../utils/thumbnailHelper';

const WebinarCard = ({ webinar }) => {
  const thumbnail = getWebinarThumbnail(webinar);
  
  return (
    <Link to={`/webinar/${webinar.webinar_id}`} data-testid={`webinar-card-${webinar.webinar_id}`}>
      <Card className="overflow-hidden h-full transition-all duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer group">
        <div className="relative overflow-hidden aspect-video">
          <img
            src={thumbnail}
            alt={webinar.title}
            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            data-testid="webinar-card-thumbnail"
            onError={(e) => {
              e.target.src = 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=450&fit=crop';
            }}
          />
          <div className="absolute top-3 left-3">
            <Badge className="bg-white/90 text-gray-900 hover:bg-white" data-testid="webinar-card-category">
              {webinar.category}
            </Badge>
          </div>
          {webinar.webinar_type && (
            <div className="absolute top-3 right-3">
              <Badge variant="secondary" className="bg-blue-600/90 text-white hover:bg-blue-600" data-testid="webinar-card-type">
                {webinar.webinar_type}
              </Badge>
            </div>
          )}
        </div>
        
        <CardContent className="p-5">
          <div className="flex items-center gap-2 mb-2">
            <Award className="h-4 w-4 text-blue-600" />
            <span className="text-xs font-medium text-blue-600" data-testid="webinar-card-level">{webinar.level}</span>
          </div>
          
          <h3 className="font-semibold text-lg mb-2 line-clamp-2 text-gray-900 group-hover:text-blue-600 transition-colors" data-testid="webinar-card-title">
            {webinar.title}
          </h3>
          
          <p className="text-sm text-gray-600 mb-4 line-clamp-2" data-testid="webinar-card-description">
            {webinar.short_description || webinar.description?.substring(0, 120) + '...' || 'Explore this webinar to learn more'}
          </p>
          
          <div className="flex items-center justify-between text-xs text-gray-500">
            <div className="flex items-center gap-1" data-testid="webinar-card-speaker">
              <User className="h-3.5 w-3.5" />
              <span>{webinar.speaker.name}</span>
            </div>
            <div className="flex items-center gap-1" data-testid="webinar-card-duration">
              <Clock className="h-3.5 w-3.5" />
              <span>{webinar.duration}</span>
            </div>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};

export default WebinarCard;
